import { Autocomplete, FormControl, Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../../app/hooks";
import { VerticalAlignGrid } from "../../../../../invoices/styled";
import CommonTextField from "../../../../../../common/components/functional/commonTextField/CommonTextField";
import { StyledFormSection } from "../../../styles";
import useTesAutocompleteQuery from "../../../../../../hooks/useTesAutocompleteQuery";

interface Props {
  disabled: boolean;
  existingTesArray: any[];
}

const TesSection = ({ disabled, existingTesArray }: Props) => {
  const { t } = useTranslation("common");
  const { control, watch } = useFormContext();
  const { tes } = useAppSelector((state) => state.localized);
  const { setTesSearchTerm, tesIdsQueryResult } = useTesAutocompleteQuery();
  const existingTesIds = existingTesArray.map((tesItem) => tesItem.tesId);

  // Pricing by salary type values depend on tesId
  // We disable the field after tesId is selected so that the user can't change it
  // and cause the pricing by salary type values to be invalid
  const isFieldDisabled = disabled || !!watch("tesId");

  return (
    <Grid marginTop="0.5rem">
      <StyledFormSection>
        <VerticalAlignGrid container spacing={1}>
          <Grid
            container
            item
            xs={3}
            justifyContent="flex-end"
            paddingRight="0.5rem"
          >
            <Typography variant="secondary">{t("tes")}</Typography>
          </Grid>
          <Grid item xs={5}>
            <FormControl fullWidth size="small">
              <Controller
                name="tesId"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <Autocomplete
                    value={value}
                    options={tesIdsQueryResult}
                    getOptionLabel={(tesId) => tes[tesId]}
                    getOptionDisabled={(tesId) =>
                      existingTesIds.includes(tesId)
                    }
                    onInputChange={(event, newInput) => {
                      if (event?.type === "change") {
                        setTesSearchTerm(newInput);
                      }
                    }}
                    onChange={(_, newTesId) => {
                      onChange(newTesId);
                    }}
                    disabled={isFieldDisabled}
                    renderInput={(params) => (
                      <CommonTextField
                        {...params}
                        name="tes"
                        label={
                          isFieldDisabled
                            ? ""
                            : t("common:searchCollectiveAgreements")
                        }
                      />
                    )}
                  />
                )}
              />
            </FormControl>
          </Grid>
        </VerticalAlignGrid>
      </StyledFormSection>
    </Grid>
  );
};

export default TesSection;
